<template>
    <div>
        <div class="upcoming-events-cards-month upcoming-events-cards-month-text">
            {{ selectedDateMonth }}
        </div>
        <div class="upcoming-events-cards-divider"></div>
        <div class="upcoming-events-cards-date upcoming-events-cards-date-text">
            {{ selectedDateStr }}
        </div>
        <v-virtual-scroll
            :height="570"
            :items="scrollItems">
            <template v-slot:default="{ item }">
                <upcoming-events-scroll-item
                :item="item"
                />
            </template>
        </v-virtual-scroll>
    </div>
</template>

<script>

import UpcomingEventsScrollItem from '@/components/upcomingEventsCards/UpcomingEventsScrollItem.vue'
import { useEventsStore } from '@/store/events'

export default {
    name: 'SvgIcon',
    data(){
        let dayToWeek = {
            0: 'Вс',
            1: 'Пн',
            2: 'Вт',
            3: 'Ср',
            4: 'Чт',
            5: 'Пт',
            6: 'Сб'
        }
        let monthToText = {
            0: 'январь',
            1: 'февраль',
            2: 'март',
            3: 'апрель',
            4: 'май',
            5: 'июнь',
            6: 'июль',
            7: 'август',
            8: 'сентябрь',
            9: 'октябрь',
            10: 'ноябрь',
            11: 'декабрь',
        }
        return {
            'dayToWeek': dayToWeek,
            'monthToText': monthToText
        }
    },
    computed: {
        selectedDateStr(){
            let eventsStore = useEventsStore()
            let dayOfWeek = this.dayToWeek[eventsStore.selectedDate.getDay()]
            let dayOfMonth = eventsStore.selectedDate.getDate()
            let monthText = this.monthToText[eventsStore.selectedDate.getMonth()]
            return dayOfWeek + ', ' + dayOfMonth + ' ' + monthText
        },
        selectedDateMonth(){
            let eventsStore = useEventsStore()
            let monthText = this.monthToText[eventsStore.selectedDate.getMonth()]
            return monthText[0].toUpperCase() + monthText.slice(1)
        },
        scrollItems(){
            let eventsStore = useEventsStore()
            let allEvents = eventsStore.eventsDateFilters
            let _scrollItems = []
            let scrollItem = []
            for (let event of allEvents){
                if (scrollItem.length == 0){
                    scrollItem.push(event)
                    continue
                }
                if (scrollItem.length == 1){
                    scrollItem.push(event)
                    _scrollItems.push(scrollItem)
                    scrollItem = []
                    continue
                }
            }
            if (scrollItem.length == 1)
                _scrollItems.push(scrollItem)
            return _scrollItems
        }
    },
    components:{
        UpcomingEventsScrollItem
    }
}
</script>